<template>
  <div class="emplmsindex" v-if="info">
    <img src="/static/images/emplimg.png">
    <p>今日福利</p>
    <img class="prize" :src="info.itemurl">
    <button class="rob" @click="rob"><img src="/static/images/emplbtn.gif"></button>
    <van-overlay
      :show="showbindphone"
      z-index="99"
    >
      <div class="bindphone" v-if="showbindphone">
        <b>恭喜你成为创客村的幸运儿!<br/>请填写领取信息</b>
        <div class="input phone">
          <input placeholder="请输入所在部门" type="text" v-model="dept">
        </div>
        <div class="input phone">
          <input placeholder="请输入姓名" type="text" v-model="name">
        </div>
        <div class="input phone">
          <input placeholder="请输入手机号" maxlength="11" type="tel" v-model="mobile">
        </div>
        <img @click="submit" class="submit" src="/static/images/shareact815/submit.png">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {fenxiang} from '../../assets/common/js/config'

export default {
  name: 'emplmsindex',
  data () {
    return {
      dept: '',
      name: '',
      mobile: '',
      showbindphone: false,
      popup: null,
      info: null,
      popuimgs: '',
      isajax: true
    }
  },
  mounted: function () {
    fenxiang({path: 'emplmsindex'})
    this.getData()
  },
  watch: {
    showbindphone (n) {
      if (!n) {
        this.dept = ''
        this.name = ''
        this.mobile = ''
      }
    }
  },
  methods: {
    getData: function () {
      var url = this.$ajax.getCkysPrizesInfo_URL
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          this.info = res.data
        }
      })
    },
    rob: function () {
      if (!this.info) {
        this.$toast('敬请期待')
      }
      if (this.isajax) {
        this.isajax = false
        var url = this.$ajax.doCkysPrizes_URL
        var data = {
          itemid: this.info.itemid,
          itemname: this.info.itemname
        }
        this.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code == 200) {
            this.isajax = false
            this.info.prizesid = res.data.prizesid
            this.showbindphone = true
            this.isajax = true
          } else {
            this.isajax = true
          }
        })
      }
    },
    submit: function () {
      if (this.isajax) {
        this.isajax = false
        var url = this.$ajax.addCkysPrizes_URL
        var data = {
          prizesid: this.info.prizesid ? this.info.prizesid : '',
          name: this.name,
          mobile: this.mobile,
          dept: this.dept
        }
        this.$customRequestAjax.post(url, data).then(res => {
          if (res.data.code == 200) {
            this.showbindphone = false
            this.isajax = true
            this.$toast(res.data.msg)
          } else {
            this.isajax = true
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .emplmsindex {
    background: linear-gradient(90deg, #d25927 0%, #fe5945 100%);
    img {
      width: 100%;
    }
    p {
      font-size: 0.18rem;
      color: #333333;
      text-align: center;
      margin: 0.1rem;
    }
    .prize {
      padding: 0 0.2rem;
      border-radius: 0.1rem;
    }
    .rob {
      border-width: 0;
      background: transparent;
      outline: none;
      margin: 0.2rem 0.7rem;
      display: block;
    }
  }
  .bindphone {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 100;
    background: #ffffff;
    width: 2.65rem;
    height: 3.2rem;
    text-align: center;
    border-radius: 0.04rem;
  }
  .bindphone .close {
    width: 0.2rem;
    height: 0.2rem;
    position: absolute;
    right: 0.15rem;
    top: 0.11rem;
  }
  .bindphone b {
    display: block;
    color: #333333;
    font-size: 0.17rem;
    margin-top: 0.22rem;
    margin-bottom: 0.22rem;
    padding: 0 0.1rem;
  }
  .bindphone .input {
    background: #F6F7FA;
    border-radius: 0.02rem;
    margin: 0.06rem auto;
    width: 2.27rem;
    height: 0.4rem;
    line-height: 0.4rem;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
  }
  .bindphone .input #codeImg {
    width: 0.8rem;
    height: 0.4rem;
  }
  .bindphone .input input {
    background: transparent;
    padding: 0.1rem 0.11rem;
    width: 100%;
    height: 100%;
    display: block;
    border-width: 0;
    outline: none;
    font-size: 0.13rem;
    color: #333333;
  }
  .bindphone .input input::placeholder {
    color: #999999;
  }
  .bindphone .input span {
    color: #AF1314;
    font-size: 0.13rem;
    line-height: 0.4rem;
    white-space: nowrap;
    padding: 0 0.1rem;
  }
  .bindphone .submit {
    width: 2.26rem;
    height: 0.47rem;
    display: block;
    margin: 0.32rem auto 0;
  }
  .bindphone .input span.countdown {
    color: #999999;
  }</style>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/emplwelfare/emplmsindex.vue